export default "/static/featured/cross-border.jpg"